import { render, staticRenderFns } from "./Pronos.vue?vue&type=template&id=3c992f3b&"
import script from "./Pronos.vue?vue&type=script&lang=js&"
export * from "./Pronos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Pronos.vue"
export default component.exports